module.exports = __webpack_public_path__ + "img/ins_step4.2cc7b4c2.svg";